import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ChampLibreGroup } from '../models/ChampLibreGroup';

@Component({
  selector: 'app-champ-libre-group',
  templateUrl: './champ-libre-group.component.html'
})
export class ChampLibreGroupComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'ChampLibreGroup';
  @Input() parentForm: FormGroup;
  @Input() champLibreGroup: ChampLibreGroup;

  constructor() {
  }

  public ngOnInit() {
  }

  public addchampsLibre() {
    this.champLibreGroup.champsLibre.push('ChampsLibre');
  }

  public removechampsLibre(i) {
    this.champLibreGroup.champsLibre.splice(i, 1);
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

